import { html } from 'lit-element';

import { SimpleLitElement } from '@elab/components';
import connect from '@elab/core/store/connect';
import { getValueByStorePath } from '@elab/core/utils/helpers';

export class FieldRefError extends SimpleLitElement {
    static get properties() {
        return {
            refName: {
                type: String,
                attribute: 'target-field',
            },
            fieldValue: { type: String },
        };
    }

    render() {
        return this.fieldValue
            ? html`
                  <span class="text form-field-ref-error">
                      ${this.fieldValue}
                  </span>
              `
            : html``;
    }
}

const mapStateToProps = (state, ctx) => ({
    fieldValue: getValueByStorePath(ctx.refName, state),
});

export default () =>
    customElements.define('e2-field-ref-error', connect(mapStateToProps)(FieldRefError));
